import VerticalBlockSettingsService from "./VerticalBlockSettingsService";

export { default } from "./VerticalBlockSettingsService";
export const verticalBlockSettingsService = new VerticalBlockSettingsService();
